import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToggleButtonComponent } from '@uigy/shared/components/toggle-button/toggle-button.component';
import { DarkModeService } from '@uigy/shared/services/dark-mode.service';
import { IconsEnum } from '@uigy/generated/icons.enum';

@Component({
  selector: 'app-dark-mode-toggle',
  templateUrl: './dark-mode-toggle.component.html',
  styleUrls: ['./dark-mode-toggle.component.scss'],
  imports: [
    ToggleButtonComponent,
    FormsModule,
    AsyncPipe,
  ],
})
export class DarkModeToggleComponent {
  darkModeService = inject(DarkModeService);

  protected readonly IconsEnum = IconsEnum;
}
